import {
	percentageBarFormatter,
	numberFormatter,
    dateFormatter,
} from "../../gridFormatters";

export const datastoreCapacityHistory = [
    {
        "field": "collection_date",
        "sort": "desc",
        "headerName": "Collection Date",
        "cellStyle": {
            "text-align": "center"
        },
        "cellRenderer": dateFormatter,
        "enableRowGroup": true
    },
    // {
    //     "field": "datastore_name",
    //     "headerName": "Datastore Name",
    //     "cellStyle": {
    //         "text-align": "center"
    //     },
    //     "enableRowGroup": true
    // },
    {
        "field": "pct_disk_used",
        "type": "numericColumn",
        "headerName": "Disk Usage %",
        "cellStyle": {
            "text-align": "right"
        },
        "aggFunc": "avg",
        "cellRenderer": percentageBarFormatter,
        "allowedAggFuncs": [
            "avg"
        ]
    },
    {
        "field": "datastore_size",
        "type": "numericColumn",
        "headerName": "Datastore Allocated",
        "cellRenderer": numberFormatter,
        "cellStyle": {
            "text-align": "right"
        },
        "aggFunc": "sum",
        "allowedAggFuncs": [
            "sum"
        ],
    },
    {
        "field": "datastore_used",
        "type": "numericColumn",
        "headerName": "Datastore Used",
        "cellRenderer": numberFormatter,
        "cellStyle": {
            "text-align": "right"
        },
        "aggFunc": "sum",
        "allowedAggFuncs": [
            "sum"
        ],
    },
    {
        "field": "esx_host_name",
        "headerName": "ESX Host Name",
        "cellStyle": {
            "text-align": "center"
        },
        "enableRowGroup": true
    }
]